module.exports = __webpack_public_path__ + "static/media/gi.a0c59870.svg";